import { Star, Trophy, Target, Activity } from "lucide-react";
import { PLAYER_OF_MONTH } from "@/data/teamData";

const ICONS = [Target, Activity, Trophy, Star];

export default function PlayerOfMonth() {
  const p = PLAYER_OF_MONTH;
  return (
    <section data-testid="player-of-month-section" className="bg-[#0A1128] text-white relative overflow-hidden">
      {/* Red glow */}
      <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-[#E63946]/20 blur-[120px]" />

      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-24 grid lg:grid-cols-12 gap-12 items-center relative z-10">
        {/* Image */}
        <div className="lg:col-span-5 relative">
          <div className="absolute -top-4 -left-4 w-24 h-24 border-l-2 border-t-2 border-[#E63946]" />
          <div className="absolute -bottom-4 -right-4 w-24 h-24 border-r-2 border-b-2 border-[#E63946]" />

          <div className="relative aspect-[4/5] overflow-hidden bg-[#050B14]">
            <img
              src={p.img}
              alt={p.name}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A1128] via-transparent to-transparent" />

            {/* Rating badge */}
            <div className="absolute top-4 right-4 bg-[#E63946] px-3 py-2 flex items-center gap-2">
              <Star size={14} fill="#fff" className="text-white" />
              <span className="font-display text-2xl leading-none">{p.rating}</span>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="lg:col-span-7 space-y-6">
          <div className="text-xs font-bold tracking-[0.3em] text-[#E63946]">PEMAIN BULAN INI</div>
          <h2 data-testid="potm-name" className="font-display text-6xl sm:text-7xl leading-none">
            {p.name}
          </h2>
          <div className="text-sm tracking-[0.3em] text-white/60">{p.position}</div>

          <p className="text-lg text-white/80 italic font-light max-w-xl border-l-2 border-[#E63946] pl-4">
            {p.quote}
          </p>

          {/* Stats */}
          <div className="grid sm:grid-cols-2 gap-4 pt-6">
            {p.stats.map((s, i) => {
              const Icon = ICONS[i] || Star;
              return (
                <div
                  key={s.label}
                  data-testid={`potm-stat-${i}`}
                  className="bg-[#050B14] border border-white/10 p-5"
                >
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2">
                      <Icon size={16} className="text-[#E63946]" />
                      <span className="text-xs tracking-[0.2em] text-white/60">{s.label}</span>
                    </div>
                    <span className="font-display text-2xl">{s.value}</span>
                  </div>
                  <div className="h-1 bg-white/10 overflow-hidden">
                    <div
                      className="h-full bg-[#E63946]"
                      style={{ width: `${s.bar}%` }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
